export const remote = 'https://bschool.nus.edu.sg/L3/api/submissions';
